import omit from "lodash/omit";
import uuid from "shortid";
export default function upsertDeleteActionGenerator(upsertAction, deleteAction) {
  return {
    [upsertAction]: (state, payload) => {
      if (!payload) return state;
      const arrayPayload = Array.isArray(payload) ? payload : [payload];
      const newState = { ...state };
      arrayPayload.forEach((item) => {
        if (!item) return;
        const idToUse = item.id || uuid();
        newState[idToUse] = { ...newState[idToUse] || {}, ...item, id: idToUse };
      });
      return newState;
    },
    [deleteAction]: (state, payload) => {
      let ids;
      if (Array.isArray(payload)) {
        ids = payload.map((val) => {
          return val.id || val;
        });
      } else {
        ids = [payload.id || payload];
      }
      return omit(state, ids);
    }
  };
}
